import * as React from "react";

import { AssetTypes } from "@eave/shared/types/api";
import APIClient from "../../../APIClient";
import LabeledInput from "../../../LabeledInput";
import accountTypeOptions from "../../../forms/data/accountTypeOptions";
import { loadApp } from "../../actions";

const { Form, Button, Modal } = require("react-bootstrap");

interface AddAssetProps {
  appId: number;
  dispatch: Function;
  onHide: Function;
}

export default class AddAsset extends React.Component<AddAssetProps, any> {
  constructor(props: AddAssetProps) {
    super(props);
    this.state = {};
  }

  handleOnSubmit(e) {
    const { dispatch, appId, onHide } = this.props;

    e.preventDefault();

    if (this.validForm()) {
      APIClient.post("/accounts", this.postData()).then(() => {
        loadApp(dispatch, appId);
        onHide();
      });
    }
  }

  validForm() {
    const { valueIsNegative } = this.state;

    let requiredFields;
    if (valueIsNegative) {
      requiredFields = ["institution", "value"];
    } else {
      requiredFields = ["institution", "type", "value"];
    }
    return requiredFields.every(attr =>
      this.state[attr] ? !!this.state[attr].trim().length : false,
    );
  }

  postData(): Object {
    const { institution, numberSuffix, valueIsNegative, value, type } = this.state;

    let val = value.replace(/,/g, "");
    if (valueIsNegative) {
      val = `-${val}`;
    }

    return {
      institution,
      loan_application_id: this.props.appId,
      number_suffix: numberSuffix,
      type: valueIsNegative ? AssetTypes.NegativeAsset : type,
      value: val,
    };
  }

  handleOnChange(e) {
    const { name, value } = e.target;

    this.setState({
      [name]: value,
    });
  }

  typeChange(option) {
    this.setState({
      type: option !== null ? option.value : null,
    });
  }

  boolChange(e) {
    this.setState({ valueIsNegative: !!e.target.checked });
  }

  render() {
    const { onHide } = this.props;

    return (
      <Modal bsSize="large" show animation={false} onHide={onHide}>
        <Modal.Header closeButton>
          <Modal.Title>Add asset</Modal.Title>
        </Modal.Header>
        <Modal.Body className="asset-summary__modal-body">
          <Form onSubmit={this.handleOnSubmit.bind(this)}>
            <LabeledInput
              inputType="text"
              inputName="institution"
              inputValue={this.state.institution}
              labelValue="Institution name"
              onChange={this.handleOnChange.bind(this)}
            />
            <LabeledInput
              inputType="text"
              inputName="numberSuffix"
              inputValue={this.state.numberSuffix}
              labelValue="Account number suffix"
              onChange={this.handleOnChange.bind(this)}
            />
            <LabeledInput
              inputType="boolean"
              inputName="negative"
              labelValue="Negative asset (i.e., a one-time payment, judgment, or liability)"
              inputValue={this.state.valueIsNegative}
              onChange={this.boolChange.bind(this)}
            />
            <LabeledInput
              inputType="money"
              inputName="value"
              labelValue="Value"
              inputValue={this.state.value}
              onChange={this.handleOnChange.bind(this)}
            />
            {!this.state.valueIsNegative && (
              <LabeledInput
                labelValue="Type"
                inputType="select"
                inputValue={this.state.type}
                options={accountTypeOptions}
                onChange={this.typeChange.bind(this)}
              />
            )}
            <Button type="submit">Save</Button>
          </Form>
        </Modal.Body>
      </Modal>
    );
  }
}
